import mixpanel from "mixpanel-browser/src/loaders/loader-module-core";
import { captureException } from "@sentry/browser";

/**
 * Initialize logout handler for Mixpanel identity cleanup.
 *
 * Attaches a click handler to the logout link that calls mixpanel.reset()
 * before navigating to the logout URL. This ensures the user's Mixpanel
 * identity is cleared when they log out.
 *
 * Uses vanilla JavaScript for lightweight implementation.
 * @returns {void}
 */
export function initLogoutHandler() {
  const logoutLink = document.getElementById("logout-link");
  if (!logoutLink) {
    return; // Graceful exit - element doesn't exist (user not logged in)
  }

  logoutLink.addEventListener("click", function (e) {
    e.preventDefault();

    // Try to reset Mixpanel, but NEVER let analytics block logout
    try {
      mixpanel.reset(); // Clear distinct_id and super properties
    } catch (error) {
      captureException(error, {
        tags: { component: "logout_handler" },
        level: "error",
      });
    }

    // Get logout URL from element, fallback to default if not found
    // Uses || instead of ?? for explicit Safari 12+ compatibility
    window.location.href = this.getAttribute("href") || "/account/logout";
  });
}
